import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  setStateName,
  setDistrictName,
  setTehsilName,
  setVillageName,
} from "../features/location/locationSlice";
import {
  fetchDistricts,
  fetchTehsils,
  fetchVillages,
} from "../features/geo/geoSlice";
import "./SelectionDropdown.css";

const SelectionDropdown = ({ onSearch }) => {
  const dispatch = useDispatch();

  // Location state
  const {
    state: selectedState,
    district: selectedDistrict,
    tehsil: selectedTehsil,
    village: selectedVillage,
  } = useSelector((s) => s.location);

  // Geo state
  const { lists, loading, geojson } = useSelector((s) => s.geo);

  const stateOptions = [
    "Rajasthan",
    "Maharashtra",
    "Andhra Pradesh",
    "Uttar Pradesh",
    "Karnataka",
  ];

  // ---------- cascading fetches ----------

  useEffect(() => {
    if (selectedState) {
      dispatch(fetchDistricts(selectedState));
    }
  }, [selectedState, dispatch]);

  useEffect(() => {
    if (selectedState && selectedDistrict) {
      dispatch(fetchTehsils({ stateName: selectedState, district: selectedDistrict }));
    }
  }, [selectedState, selectedDistrict, dispatch]);

  useEffect(() => {
    if (selectedState && selectedDistrict && selectedTehsil) {
      dispatch(
        fetchVillages({
          stateName: selectedState,
          district: selectedDistrict,
          tehsil: selectedTehsil,
        })
      );
    }
  }, [selectedState, selectedDistrict, selectedTehsil, dispatch]);

  // ---------- emit data to parent (DEMView) ----------

  useEffect(() => {
    if (selectedState && !selectedDistrict && !selectedTehsil) {
      onSearch(selectedState, null, null, null, geojson.district);
    } else if (selectedState && selectedDistrict && !selectedTehsil) {
      onSearch(selectedState, selectedDistrict, null, null, geojson.district);
    } else if (selectedState && selectedDistrict && selectedTehsil && !selectedVillage) {
      onSearch(
        selectedState,
        selectedDistrict,
        selectedTehsil,
        null,
        geojson.tehsil
      );
    }
  }, [selectedState, selectedDistrict, selectedTehsil, geojson.district, geojson.tehsil]);

  useEffect(() => {
    if (
      selectedState &&
      selectedDistrict &&
      selectedTehsil &&
      selectedVillage
    ) {
      onSearch(
        selectedState,
        selectedDistrict,
        selectedTehsil,
        selectedVillage,
        geojson.village
      );
    }
  }, [selectedVillage, geojson.village]);

  // ---------- render ----------

  return ( 
    <div className="selection-dropdown-container">
      {/* Dropdown Grid */}
      <div className="dropdown-grid">
        {/* State */}
        <div className="dropdown-field-wrapper">
          <div className="dropdown-field">
            <div className="dropdown-icon">
            </div>
            <select
              value={selectedState}
              // onChange={(e) => {
              //   dispatch(setStateName(e.target.value));
              // }}
              onChange={(e) => {
  const value = e.target.value;
  dispatch(setStateName(value));
  dispatch(setDistrictName(""));
  dispatch(setTehsilName(""));
  dispatch(setVillageName(""));

  localStorage.setItem("selectedState", value);
  localStorage.removeItem("selectedDistrict");
  localStorage.removeItem("selectedTehsil");
  localStorage.removeItem("selectedVillage");
}}
              className="dropdown modern-dropdown"
            >
              <option value="">Select State</option>
              {stateOptions.map((state) => (
                <option key={state} value={state}>
                  {state}
                </option>
              ))}
            </select>
            <div className="dropdown-chevron">
            </div>
          </div>
        </div>

        {/* District */}
        <div className="dropdown-field-wrapper">
          <div className="dropdown-field">
            <div className="dropdown-icon">
            </div>
            <select
              value={selectedDistrict}
              // onChange={(e) => {
              //   dispatch(setDistrictName(e.target.value));
              // }}
              onChange={(e) => {
  const value = e.target.value;
  dispatch(setDistrictName(value));
  dispatch(setTehsilName(""));
  dispatch(setVillageName(""));

  localStorage.setItem("selectedDistrict", value);
  localStorage.removeItem("selectedTehsil");
  localStorage.removeItem("selectedVillage");
}}
              disabled={!selectedState}
              className={`dropdown modern-dropdown ${!selectedState ? 'disabled' : ''}`}
            >
              <option value="">
                {loading.districts ? 'Loading...' : 'Select District'}
              </option>
              {lists.districts.length > 0 ? (
                lists.districts.map((district) => (
                  <option key={district} value={district}>
                    {district}
                  </option>
                ))
              ) : selectedState && !loading.districts ? (
                <option value="">No districts available</option>
              ) : null}
            </select>
            <div className="dropdown-chevron">
              {loading.districts ? (
                <div className="loading-spinner"></div>
              ) : (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <polyline points="6,9 12,15 18,9"></polyline>
                </svg>
              )}
            </div>
          </div>
          {loading.districts && (
            <div className="progress-bar">
              <div className="progress-fill"></div>
            </div>
          )}
        </div>

        {/* Tehsil */}
        <div className="dropdown-field-wrapper">
          <div className="dropdown-field">
            <div className="dropdown-icon">
            </div>
            <select
              value={selectedTehsil || ""}
              // onChange={(e) => {
              //   dispatch(setTehsilName(e.target.value));
              // }}
              onChange={(e) => {
  const value = e.target.value;
  dispatch(setTehsilName(value));
  dispatch(setVillageName(""));

  localStorage.setItem("selectedTehsil", value);
  localStorage.removeItem("selectedVillage");
}}
              disabled={!selectedDistrict}
              className={`dropdown modern-dropdown ${!selectedDistrict ? 'disabled' : ''}`}
            >
              <option value="" disabled>
                {loading.tehsils ? 'Loading...' : 'Select Tehsil'}
              </option>
              {lists.tehsils.map((tehsil) => (
                <option key={tehsil} value={tehsil}>
                  {tehsil}
                </option>
              ))}
            </select>
            <div className="dropdown-chevron">
              {loading.tehsils ? (
                <div className="loading-spinner"></div>
              ) : (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <polyline points="6,9 12,15 18,9"></polyline>
                </svg>
              )}
            </div>
          </div>
          {loading.tehsils && (
            <div className="progress-bar">
              <div className="progress-fill"></div>
            </div>
          )}
        </div>

        {/* Village */}
        <div className="dropdown-field-wrapper">
          <div className="dropdown-field">
            <div className="dropdown-icon">
            </div>
            <select
              value={selectedVillage}
              // onChange={(e) => dispatch(setVillageName(e.target.value))}
              onChange={(e) => {
  const value = e.target.value;
  dispatch(setVillageName(value));
  localStorage.setItem("selectedVillage", value);
}}
              disabled={!selectedTehsil}
              className={`dropdown modern-dropdown ${!selectedTehsil ? 'disabled' : ''}`}
            >
              <option value="">
                {loading.villages ? 'Loading...' : 'Select Village'}
              </option>
              {lists.villages.map((village) => (
                <option key={village} value={village}>
                  {village}
                </option>
              ))}
            </select>
            <div className="dropdown-chevron">
              {loading.villages ? (
                <div className="loading-spinner"></div>
              ) : (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <polyline points="6,9 12,15 18,9"></polyline>
                </svg>
              )}
            </div>
          </div>
          {loading.villages && (
            <div className="progress-bar">
              <div className="progress-fill"></div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SelectionDropdown;